import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() || ''
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() || ''

let browserClient

export const supabaseEnv = {
  hasUrl: Boolean(supabaseUrl),
  hasKey: Boolean(supabaseKey),
  isReady: Boolean(supabaseUrl && supabaseKey),
}

export function getSupabaseClient() {
  if (!supabaseEnv.isReady) return null

  if (!browserClient) {
    browserClient = createClient(supabaseUrl, supabaseKey, {
      auth: {
        autoRefreshToken: true,
        // Authentication is completed explicitly with the emailed one-time code.
        detectSessionInUrl: false,
        persistSession: true,
      },
    })
  }

  return browserClient
}

export function requireSupabaseClient() {
  const client = getSupabaseClient()
  if (!client) {
    throw new Error('Supabase browser env vars are missing.')
  }
  return client
}
